import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer } from '../hooks/useScrollAnimation';
import { BookOpen, Mic } from 'lucide-react';
export function PublicationsSection() {
  return <section id="publications" className="py-20 bg-dark-bg border-t border-dark-border/30" data-id="element-377">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-378">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={staggerContainer} data-id="element-379">
          <motion.div variants={fadeInUp} className="mb-16" data-id="element-380">
            <span className="font-sans text-gold/80 tracking-widest uppercase text-xs font-semibold mb-2 block" data-id="element-381">
              Thought Leadership
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-382">
              Publications & Speaking
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-383">
            {/* Publications */}
            <div data-id="element-384">
              <div className="flex items-center gap-3 mb-8" data-id="element-385">
                <BookOpen className="w-6 h-6 text-cyan" data-id="element-386" />
                <h3 className="text-2xl font-bold text-white" data-id="element-387">Publications</h3>
              </div>
              <div className="space-y-4" data-id="element-388">
                {[{
                title: 'Engineering Resilience',
                publisher: "O'Reilly Media",
                year: '2023'
              }, {
                title: 'The Zero-Trust Enterprise',
                publisher: 'Harvard Business Review',
                year: '2022'
              }, {
                title: 'Cloud Migration at Scale',
                publisher: 'IEEE Conference',
                year: '2021'
              }, {
                title: 'Future of Infrastructure',
                publisher: 'MIT Technology Review',
                year: '2020'
              }].map((pub, i) => <motion.div key={i} variants={fadeInUp} className="flex justify-between items-center p-4 bg-dark-card border border-dark-border rounded-lg hover:border-cyan/30 transition-colors" data-id="element-389">
                    <div data-id="element-390">
                      <div className="text-white font-medium" data-id="element-391">{pub.title}</div>
                      <div className="text-cyan text-sm" data-id="element-392">{pub.publisher}</div>
                    </div>
                    <div className="font-mono text-gold text-sm" data-id="element-393">
                      {pub.year}
                    </div>
                  </motion.div>)}
              </div>
            </div>

            {/* Speaking */}
            <div data-id="element-394">
              <div className="flex items-center gap-3 mb-8" data-id="element-395">
                <Mic className="w-6 h-6 text-cyan" data-id="element-396" />
                <h3 className="text-2xl font-bold text-white" data-id="element-397">Speaking</h3>
              </div>
              <div className="space-y-4" data-id="element-398">
                {[{
                event: 'AWS re:Invent 2024',
                role: 'Keynote Speaker'
              }, {
                event: 'Gartner IT Symposium 2023',
                role: 'Panel Chair'
              }, {
                event: 'RSA Conference 2023',
                role: 'Featured Speaker'
              }, {
                event: 'World Economic Forum 2022',
                role: 'Technology Panel'
              }].map((speak, i) => <motion.div key={i} variants={fadeInUp} className="flex justify-between items-center p-4 bg-dark-card border border-dark-border rounded-lg hover:border-cyan/30 transition-colors" data-id="element-399">
                    <div data-id="element-400">
                      <div className="text-white font-medium" data-id="element-401">
                        {speak.event}
                      </div>
                      <div className="text-cyan text-sm" data-id="element-402">{speak.role}</div>
                    </div>
                  </motion.div>)}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}